export const SHARE_ACTIONS_COPY = {
  revoke: "Revoke link",
  reset: "Reset link",
  hint: "Revoke: the link stops working now. Reset: makes a new link and kills the old one.",
  revokeConfirm: "Revoke the link? It stops working now. Revoke now?",
  revokeYes: "Yes, revoke",
  resetConfirm: "Reset makes a new link; the old one stops working. Reset now?",
  resetYes: "Yes, reset",
  cancel: "Cancel",
} as const;
